import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/input/inputbase
 */
import View from '../view.js';
import { FocusTracker } from '@ckeditor/ckeditor5-utils';
/**
 * The base input view class.
 */
var InputBase = /*#__PURE__*/function (_View) {
  _inherits(InputBase, _View);
  var _super = _createSuper(InputBase);
  /**
   * @inheritDoc
   */
  function InputBase(locale) {
    var _this;
    _classCallCheck(this, InputBase);
    _this = _super.call(this, locale);
    _this.set('value', undefined);
    _this.set('id', undefined);
    _this.set('placeholder', undefined);
    _this.set('isReadOnly', false);
    _this.set('hasError', false);
    _this.set('ariaDescribedById', undefined);
    _this.focusTracker = new FocusTracker();
    _this.bind('isFocused').to(_this.focusTracker);
    _this.set('isEmpty', true);
    var bind = _this.bindTemplate;
    _this.setTemplate({
      tag: 'input',
      attributes: {
        class: ['ck', 'ck-input', bind.if('isFocused', 'ck-input_focused'), bind.if('isEmpty', 'ck-input-text_empty'), bind.if('hasError', 'ck-error')],
        id: bind.to('id'),
        placeholder: bind.to('placeholder'),
        readonly: bind.to('isReadOnly'),
        'aria-invalid': bind.if('hasError', true),
        'aria-describedby': bind.to('ariaDescribedById')
      },
      on: {
        input: bind.to(function () {
          var _this2;
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          (_this2 = _this).fire.apply(_this2, ['input'].concat(args));
          _this._updateIsEmpty();
        }),
        change: bind.to(_this._updateIsEmpty.bind(_assertThisInitialized(_this)))
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(InputBase, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      _get(_getPrototypeOf(InputBase.prototype), "render", this).call(this);
      this.focusTracker.add(this.element);
      this._setDomElementValue(this.value);
      this._updateIsEmpty();
      // Bind `this.value` to the DOM element's value.
      // We cannot use `value` DOM attribute because removing it on Edge does not clear the DOM element's value property.
      this.on('change:value', function (evt, name, value) {
        _this3._setDomElementValue(value);
        _this3._updateIsEmpty();
      });
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(InputBase.prototype), "destroy", this).call(this);
      this.focusTracker.destroy();
    }
    /**
     * Moves the focus to the input and selects the value.
     */
  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
    /**
     * Focuses the input.
     */
  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
    /**
     * Resets the value of the input
     */
  }, {
    key: "reset",
    value: function reset() {
      this.value = this.element.value = '';
      this._updateIsEmpty();
    }
    /**
     * Updates the {@link #isEmpty} property value on demand.
     */
  }, {
    key: "_updateIsEmpty",
    value: function _updateIsEmpty() {
      this.isEmpty = isInputElementEmpty(this.element);
    }
    /**
     * Sets the `value` property of the {@link #element DOM element} on demand.
     */
  }, {
    key: "_setDomElementValue",
    value: function _setDomElementValue(value) {
      this.element.value = !value && value !== 0 ? '' : value;
    }
  }]);
  return InputBase;
}(View);
export { InputBase as default };
function isInputElementEmpty(domElement) {
  return !domElement.value;
}